<template>
  <h1>加購品</h1>
</template>

<script>
export default {}
</script>

<style></style>
